module.exports = __webpack_public_path__ + "img/logo_NU.5f9e346d.jpg";